module.exports = __webpack_public_path__ + "img/181.160de0a8.jpg";